import moment from 'moment';

const inputDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const outputDateTimeFormat = 'DD. MMM YYYY, HH:mm:ss';
// const timeFormat = "HH:ss";

export default {
  computed: {
    parseDate() {
      return (inputString) => {
        if (inputString) { return moment(inputString, inputDateTimeFormat).format(outputDateTimeFormat); }
        return '-';
      };
    },
  },
};
